// Department-wise Employee Count Data
const departmentEmployeeData = [
  { value: 42, name: 'Engineering' },
  { value: 18, name: 'QA' },
  { value: 12, name: 'Product' },
  { value: 15, name: 'Design' },
  { value: 20, name: 'Support' },
  { value: 10, name: 'DevOps' },
  { value: 8, name: 'Security' },
  { value: 14, name: 'Infra' },
  { value: 9, name: 'Data' }
];

const DepartmentEmployeePieConfig = (data = departmentEmployeeData) => {
  // Correct total calculation
  const total = data.reduce((sum, item) => sum + item.value, 0);

  // Corrected processedData mapping
  const processedData = data.map((item, index) => ({
    name: item.name,
    value: item.value,
    itemStyle: {
      color: item.color || [
        '#4C8DFF', '#45B6A8', '#F39C12', '#A66CFF', '#22A699',
        '#E74C3C', '#1ABC9C', '#9B59B6', '#FF7F50'
      ][index % 9]
    }
  }));

  return {
    animationDuration: 1000,
    animationEasing: 'cubicOut',

    tooltip: {
      trigger: 'item',
      formatter: ({ name, value, percent }) => {
        return `
          <div style="font-weight:bold; margin-bottom:4px;">${name}</div>
          <div>Employees: ${value}<br/>Share: ${percent}%</div>
        `;
      }
    },

    legend: {
      show: false
    },

    graphic: {
      type: 'group',
      left: 'center',
      top: 'center',
      children: [
        {
          type: 'text',
          style: {
            text: 'Total',
            fontSize: 14,
            fill: '#666',
            textAlign: 'center'
          },
          top: -12
        },
        {
          type: 'text',
          style: {
            text: total.toString(),
            fontSize: 28,
            fontWeight: 'bold',
            fill: '#000',
            textAlign: 'center'
          },
          top: 10
        }
      ]
    },

    series: [
      {
        name: 'Employee Count',
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,

        itemStyle: {
          borderRadius: 6,
          borderColor: '#fff',
          borderWidth: 2
        },

        label: {
          show: true,
          position: 'outside',
          formatter: '{b}: {d}%',
          fontSize: 13
        },

        labelLine: {
          show: true,
          length: 15,
          length2: 10
        },

        data: processedData
      }
    ]
  };
};

export default DepartmentEmployeePieConfig;
